/**
 * Gemeinsamer API-Zugang der neuen Seiten.
 *
 * Der Origin kommt wie bisher aus VITE_API_BASE_URL -- nur der Origin, ohne
 * "/api". Ein angehaengtes "/api" wird toleriert, damit eine alte .env nicht
 * bricht (dieselbe Regel wie im AuthContext).
 */
const roh: string =
  ((import.meta as any).env?.VITE_API_BASE_URL as string | undefined) || 'http://localhost:8000'

export const API_BASE = roh.replace(/\/api\/?$/, '').replace(/\/$/, '')

export class ApiError extends Error {
  readonly status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

interface Optionen {
  method?: 'GET' | 'POST' | 'DELETE'
  body?: unknown
  /** true: nur angemeldet · 'optional': Token mitschicken, wenn es eins gibt */
  auth?: boolean | 'optional'
}

export async function apiFetch<T>(pfad: string, opt: Optionen = {}): Promise<T> {
  const headers: Record<string, string> = { Accept: 'application/json' }
  if (opt.body !== undefined) headers['Content-Type'] = 'application/json'
  if (opt.auth) {
    const token = localStorage.getItem('auth_token')
    if (token) headers.Authorization = `Bearer ${token}`
    else if (opt.auth !== 'optional') throw new ApiError(401, 'Nicht angemeldet.')
  }

  let antwort: Response
  try {
    antwort = await fetch(`${API_BASE}${pfad}`, {
      method: opt.method ?? 'GET',
      headers,
      body: opt.body !== undefined ? JSON.stringify(opt.body) : undefined,
    })
  } catch {
    throw new ApiError(0, 'Keine Verbindung zum Server. Bitte später erneut versuchen.')
  }

  if (!antwort.ok) {
    let text = `Anfrage fehlgeschlagen (HTTP ${antwort.status}).`
    try {
      const inhalt = await antwort.json()
      if (typeof inhalt?.detail === 'string') text = inhalt.detail
    } catch {
      // Keine JSON-Antwort -- dann bleibt es beim HTTP-Status.
    }
    throw new ApiError(antwort.status, text)
  }
  return antwort.json() as Promise<T>
}

export function fehlerText(fehler: unknown): string {
  if (fehler instanceof Error && fehler.message) return fehler.message
  return 'Unbekannter Fehler.'
}
